export class GetUntrustedPayload {
    constructor(decryptMessage) {
        this.decryptMessage = decryptMessage;
    }
    execute(dto) {
        const result = this.decryptMessage.execute({
            message: dto.payload.encrypted_message,
            sender: undefined,
            privateKey: dto.privateKey,
        });
        return result;
    }
}
